import React, { useCallback, useEffect, useState } from 'react';
import { Card } from '../../components/ui/card';
import { expensesApi } from '../api';
import { centsToDollarString } from '../constants';
import { ExpensesView } from './ExpensesView';

const Stat = ({ label, value, testId }) => (
  <Card className="bg-[#161616] border-gray-800 p-4" data-testid={testId}>
    <div className="text-xs text-gray-500 uppercase tracking-wide">{label}</div>
    <div className="text-xl font-bold text-white mt-1">{value}</div>
  </Card>
);

export const ProjectExpensesTab = ({ project }) => {
  const [summary, setSummary] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const archived = Boolean(project.is_archived);

  const loadSummary = useCallback(() => {
    expensesApi.summary({ project_id: project.id }).then((r) => setSummary(r.data)).catch(() => {});
  }, [project.id]);

  useEffect(() => { loadSummary(); }, [loadSummary, refreshKey]);

  return (
    <div data-testid="project-expenses-tab">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-white">Expenses</h3>
        <p className="text-sm text-gray-500">
          Direct spending recorded for this project. Receipts are uploaded in the Financials tab.
        </p>
      </div>

      {archived && (
        <Card className="bg-[#1A1206] border-amber-900/50 p-3 mb-4">
          <p className="text-sm text-amber-400" data-testid="project-expenses-archived-note">
            This Project is archived. Existing financial records are preserved, but new Expenses cannot be added.
          </p>
        </Card>
      )}

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 mb-6">
        <Stat label="Recorded Expenses" value={summary ? centsToDollarString(summary.total_expenses_cents) || '$0.00' : '—'} testId="project-stat-recorded-expenses" />
        <Stat label="Expenses" value={summary ? summary.expense_count : '—'} testId="project-stat-expense-count" />
        <Stat label="Receipts" value={summary ? summary.receipt_count : '—'} testId="project-stat-receipt-count" />
      </div>

      <ExpensesView
        lockedProjectId={project.id}
        projectArchived={archived}
        onChanged={() => setRefreshKey((k) => k + 1)}
      />
    </div>
  );
};
